// extracted by mini-css-extract-plugin
export default {"loginBox":"Login_loginBox__upQPW"};